import {WorkshopOverviewTileConfig} from '../types/WorkshopOverviewTileConfig';

export const WORKSHOP_SERVICE_ORDER_GRID_CODE = 'service-order';
export const WORKSHOP_SERVICE_CASE_GRID_CODE = 'service-case';

const SERVICE_ORDER_STATE_KEY = 'orderState';
const SERVICE_ORDER_STATE_OPEN_LOCKED = ['OPEN', 'LOCKED'];

const SERVICE_CASE_STATE_KEY = 'state';
const SERVICE_CASE_STATE_PLANNED = ['PLANNED'];

const MARKERS_KEY = 'markers';
const MARKER_OVERPRICED = 'SVCTAGVALUE_ORDER_OVERPRICED';
const MARKER_OVERDUE = 'SVCTAGVALUE_COMPLETION_OVERDUE';
const MARKER_REPEATED_REPAIR = 'SVCTAGVALUE_REPEATED_REPAIR';

const SERVICE_ORDER_TYPE_KEY = 'orderType';
const SERVICE_ORDER_TYPE_WARRANTY_CLAIM = ['WAR', 'CLA'];

const COMPLETION_DATE_KEY = 'completionDate';
const ESTIMATED_PRICE_KEY = 'estimatedPrice';
const ABOVE_MINIMUM_MARGIN_KEY = 'isAboveMinimumMargin';
const SCHEDULED_CHECK_IN_DATE_KEY = 'scheduledCheckinDate';

const SCHEDULED_CHECK_IN_DATE_IN_PAST = 'IN_PAST';

const QUICK_FILTER_EMPTY = 'QUICK_FILTER_EMPTY';
const RELATIVE_DATE_TODAY = 'TODAY';

export const WORKSHOP_OVERVIEW_TILES: readonly WorkshopOverviewTileConfig[] = [
  {
    id: 'vehiclesNotArrived',
    section: 'critical',
    settingsKey: 'workshopVehiclesNotArrived',
    labelKey: 'page.myProfile.dashboard.labels.vehiclesNotArrived',
    icon: 'action/visibility_off',
    gridCode: WORKSHOP_SERVICE_CASE_GRID_CODE,
    filters: {
      [SERVICE_CASE_STATE_KEY]: SERVICE_CASE_STATE_PLANNED,
      [SCHEDULED_CHECK_IN_DATE_KEY]: SCHEDULED_CHECK_IN_DATE_IN_PAST,
    },
  },
  {
    id: 'overpricedOrders',
    section: 'critical',
    settingsKey: 'workshopOverpricedOrders',
    labelKey: 'page.myProfile.dashboard.labels.overpricedOrders',
    icon: 'action/receipt',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [MARKERS_KEY]: [MARKER_OVERPRICED],
    },
  },
  {
    id: 'overdueOrders',
    section: 'critical',
    settingsKey: 'workshopOverdueOrders',
    labelKey: 'page.myProfile.dashboard.labels.overdueOrders',
    icon: 'action/history',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [MARKERS_KEY]: [MARKER_OVERDUE],
    },
  },
  {
    id: 'ordersBelowMinimumMargin',
    section: 'critical',
    settingsKey: 'workshopOrdersBelowMinimumMargin',
    labelKey: 'page.myProfile.dashboard.labels.ordersBelowMinimumMargin',
    icon: 'navigation/arrow_downward',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [ABOVE_MINIMUM_MARGIN_KEY]: ['FALSE'],
    },
  },
  {
    id: 'unclosedWarrantyClaims',
    section: 'warning',
    settingsKey: 'workshopUnclosedWarrantyClaims',
    labelKey: 'page.myProfile.dashboard.labels.unclosedWarrantyClaims',
    icon: 'hardware/security',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [SERVICE_ORDER_TYPE_KEY]: SERVICE_ORDER_TYPE_WARRANTY_CLAIM,
    },
  },
  {
    id: 'ordersWithoutCompletionDate',
    section: 'warning',
    settingsKey: 'workshopOrdersWithoutDateOrPrice',
    labelKey: 'entity.order.labels.noCompletionDate',
    icon: 'action/calendar_today',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [COMPLETION_DATE_KEY]: QUICK_FILTER_EMPTY,
    },
  },
  {
    id: 'ordersWithoutEstimatedPrice',
    section: 'warning',
    settingsKey: 'workshopOrdersWithoutDateOrPrice',
    labelKey: 'page.myProfile.dashboard.labels.ordersWithoutEstimatedPrice',
    icon: 'editor/attach_money',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [ESTIMATED_PRICE_KEY]: QUICK_FILTER_EMPTY,
    },
  },
  {
    id: 'repeatedRepairs',
    section: 'warning',
    settingsKey: 'workshopRepeatedRepairs',
    labelKey: 'page.myProfile.dashboard.labels.repeatedRepairs',
    icon: 'action/autorenew',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [MARKERS_KEY]: [MARKER_REPEATED_REPAIR],
    },
  },
  {
    id: 'toCompleteToday',
    section: 'today',
    settingsKey: 'workshopToCompleteToday',
    labelKey: 'page.myProfile.dashboard.labels.toCompleteToday',
    icon: 'action/done_all',
    gridCode: WORKSHOP_SERVICE_ORDER_GRID_CODE,
    filters: {
      [SERVICE_ORDER_STATE_KEY]: SERVICE_ORDER_STATE_OPEN_LOCKED,
      [COMPLETION_DATE_KEY]: RELATIVE_DATE_TODAY,
    },
  },
  {
    id: 'todaysVehicleArrivals',
    section: 'today',
    settingsKey: 'workshopTodaysVehicleArrivals',
    labelKey: 'page.myProfile.dashboard.labels.todaysVehicleArrivals',
    icon: 'maps/directions_car',
    gridCode: WORKSHOP_SERVICE_CASE_GRID_CODE,
    filters: {
      [SERVICE_CASE_STATE_KEY]: SERVICE_CASE_STATE_PLANNED,
      [SCHEDULED_CHECK_IN_DATE_KEY]: RELATIVE_DATE_TODAY,
    },
  },
];
